/**
 * See: https://learn.microsoft.com/en-us/graph/api/user-list-transitivememberof?view=graph-rest-1.0&tabs=http
 */
import { useGraphApi } from './useGraphApi';

type TransitiveMember = {
	id: string;
	mail?: string;
	displayName: string;
};

type TransitiveMemberOfResponse = {
	value?: TransitiveMember[];
};

export const useTransitiveMemberOf = () => {
	const res = useGraphApi<TransitiveMemberOfResponse>(
		'/me/transitiveMemberOf?$select=id,mail,displayName',
		{
			refreshInterval: 1000 * 60 * 60 /* 1 hour */,
		},
	);

	return {
		...res,
		data: res.data?.value,
	};
};
